import api from "./api";
import { fetchTraderProductList } from "./products";

export async function fetchPrices(memberRoleId) {
  // Use trader product list API
  try {
    const products = await fetchTraderProductList();

    // Transform products to categories format
    // Group all products under a single "طلا" category
    const categories = [
      {
        id: "cat-gold",
        title: "طلا",
        items: products.map((product) => {
          // Extract values from buyPrice and sellPrice objects
          const buyPriceValue = typeof product.buyPrice === 'object' && product.buyPrice !== null
            ? product.buyPrice.value
            : product.buyPrice || 0;
          const sellPriceValue = typeof product.sellPrice === 'object' && product.sellPrice !== null
            ? product.sellPrice.value
            : product.sellPrice || 0;

          // If isEnable is false, both buy and sell are disabled
          const productEnabled = product.isEnable !== false;
          const buyEnabled = productEnabled ? (product.buyIsEnable !== false) : false;
          const sellEnabled = productEnabled ? (product.sellIsEnable !== false) : false;

          // productVariableType from API: 1 = weight (وزن دلخواه), 2 = count (تعداد)
          const productVariableType = product.productVariableType;
          const unitType = productVariableType === 2 ? 'COUNT' : 'GRAM18';

          return {
            id: product.id,
            name: product.name,
            buy: String(buyPriceValue),
            sell: String(sellPriceValue),
            buyEnabled,
            sellEnabled,
            isEnable: product.isEnable,
            buyPrice: product.buyPrice,
            sellPrice: product.sellPrice,
            productVariableType,
            unit: product.unit ?? null,
            karat: product.karat ?? null,
            unitType,
            startTime: product.startTime || null,
            endTime: product.endTime || null,
            lastPriceUpdateTime: new Date().toISOString(),
          };
        }),
      },
    ];

    return categories;
  } catch (error) {
    console.error("Error fetching trader prices:", error);
    // Fallback to original API if trader API fails
    const params = memberRoleId ? { memberRoleId } : {};
    const res = await api.get("/prices", { params });
    return res.data;
  }
}

export async function updatePrice({ categoryId, itemId, premium, spread }) {
  await api.put("/prices", { categoryId, itemId, premium, spread });
}

// Role-based price management
export async function getRoleProductPrices(memberRoleId) {
  const res = await api.get(`/prices/roles/${memberRoleId}`);
  return res.data;
}

export async function updateRoleProductPrice(memberRoleId, { productId, premium, spread, startTime, endTime, buyEnabled, sellEnabled }) {
  const res = await api.put(`/prices/roles/${memberRoleId}`, { productId, premium, spread, startTime, endTime, buyEnabled, sellEnabled });
  return res.data;
}

export async function deleteRoleProductPrice(memberRoleId, productId) {
  await api.delete(`/prices/roles/${memberRoleId}/products/${productId}`);
}

export async function backfillRolePrices(memberRoleId) {
  const res = await api.post(`/prices/roles/${memberRoleId}/backfill`);
  return res.data;
}


